import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppVersion, WhatsNewUrl } from '@core';
import { WhatsNewFile } from '../../models/whats-new.model';

@Injectable({ providedIn: 'root' })
export class WhatsNewDataService {
  private readonly http: HttpClient = inject(HttpClient);

  // Best-effort: każdy błąd (brak sieci / 404 / zepsuty JSON) → null, nigdy nie rzucamy.
  // Cache-buster (wersja + timestamp), żeby poprawka treści na CDN nie czekała w cache.
  async fetch(): Promise<WhatsNewFile | null> {
    const url: string = `${WhatsNewUrl}?v=${AppVersion}&t=${Date.now()}`;
    try {
      return await firstValueFrom(this.http.get<WhatsNewFile>(url));
    } catch {
      return null;
    }
  }
}
